import React, { useState } from 'react';
// import { useDispatch } from 'react-redux'
import {
    IconLoad, IconTestpress, ConfirmModal,
} from '@Knowledge-OTP/znk-ui-components'
import useCreateTestpressUser from './useCreateTestpressUser'
import "./index.css"
import { TabContent, TabPane, Badge } from 'reactstrap'
import useTranslation from '../../../../../../i18n/useTranslation'
const CreateTestpressUser = (props) => {
    //eslint-disable-next-line
    const { onClick = () => { }, className = '', user, ...otherProps } = props
    const [isModalOpen, setModalOpen] = useState(false);
    const toggleModal = () => setModalOpen(!isModalOpen);
    // const dispatch = useDispatch()
    const { submit, loading } = useCreateTestpressUser(
        () => {
            // Callback onSuccess (opcional)
            setModalOpen(false); // cerrar modal después de confirmar
            // showAlert({
            //     text: "Usuario creado en Testpress correctamente",
            //     status: 'success'
            // }, dispatch)
            // console.log("Usuario creado en Testpress correctamente")
        },
        (err) => {

            // Callback onError (opcional)
            // showAlert({
            //     text: "Error creando el usuario:", err,
            //     status: 'error'
            // }, dispatch)
            // console.error("Error creando el usuario:", err)
        }
    )

    const { translate } = useTranslation()

    // const handleClick = () => {
    //     const variables = {
    //         id: user.id,
    //         firstName: user.firstName,
    //         lastName: user.lastName,
    //         email: user.emails?.[0]?.address ?? '', // el email no está al nivel raíz
    //         // country: user.country?.name ?? '',
    //         // phone: user.phone ?? '',
    //         state: user?.state ?? '',
    //         timezone: user.timezone ?? '',
    //         birthDate: user.birthdate ?? '',
    //     };
    //     submit(variables)
    // }
    const handleClick = () => {
        if (user && !loading) {
            setModalOpen(true); // ahora solo abre el modal
        }
    };
    const handleConfirm = () => {
        const variables = {
            id: user.id,
            firstName: user.firstName,
            lastName: user.lastName,
            email: user.emails?.[0]?.address ?? '',
            state: user?.state ?? '',
            timezone: user.timezone ?? '',
            birthDate: user.birthdate ?? '',
        };
        submit(variables);
        
    };


    return (
        <div
            onClick={() => {
                if (user && !loading) { handleClick() }
            }}
            className={`cursor-pointer position-relative d-flex flex-row align-items-center justify-content-center ${className}`}
            {...otherProps}
        >
            {
                loading && (
                    <div className='position-absolute'>
                        <TabContent activeTab={loading ? 'icon' : 'none'}>
                            <TabPane tabId={'icon'}><IconLoad size={34} /></TabPane>
                            <TabPane tabId={'none'}></TabPane>
                        </TabContent>
                    </div>
                )
            }
            <div className='w-inherit h-100'>
                <Badge className='badge badge-pill d-flex flex-row align-items-center py-1 mx-2'
                    style={{ backgroundColor: '#2E86DE', cursor: 'pointer', outline: 'none', boxShadow: 'none' }}
                >
                    <IconTestpress className='mr-1' size={16} />
                    <span style={{ color: '#FFFFFF' }}>{translate("profile.modal.buttons.testpress")}</span>
                </Badge>
            </div>
            <ConfirmModal
                isOpen={isModalOpen}
                toggle={toggleModal}
                backdrop={'static'}
                title={translate('profile.modal.testpress.title')}
                body={translate('profile.modal.testpress.body')}
                loading={loading}
                confirmAction={handleConfirm}
                cancelAction={toggleModal}
                confirmText={translate('profile.modal.testpress.confirm')}
                cancelText={translate('profile.modal.testpress.cancel')}
            />

        </div>
    )
}

export default CreateTestpressUser